import { Fragment } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { PopoverDirectionTitle } from "../../../constants";
import { PopoverDirectionSubTitle, PopoverPositions } from "../../../data/uiKits/Popover";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import CommonPopover from "./common/CommonPopover";

const PopoverDirection = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={PopoverDirectionTitle} span={PopoverDirectionSubTitle} />
        <CardBody className="common-flex">
          {PopoverPositions &&
            PopoverPositions.map((item, index) => (
              <Fragment key={index}>
                <CommonPopover data={item} />
              </Fragment>
            ))}
        </CardBody>
      </Card>
    </Col>
  );
};
export default PopoverDirection;
